import React from 'react';
import { motion } from 'framer-motion';

const stylesData = [
  {
    title: 'Blackwork',
    desc: 'Characterized by bold, solid, black lines and heavy shading. This style often incorporates geometric patterns, mandalas, or illustrative dark art. It heals incredibly well and stands the test of time.',
    sizing: 'Medium to Large',
    priceGuide: '$$$',
    img: 'https://images.unsplash.com/photo-1598371839696-5c5bb00bdc28?auto=format&fit=crop&q=80&w=800' // Dark aesthetic
  },
  {
    title: 'Fine Line',
    desc: 'Delicate, intricate, and often minimalist. Using single needles or very small groupings to create soft, elegant designs. Perfect for subtle placements and first tattoos.',
    sizing: 'Small to Medium',
    priceGuide: '$$',
    img: 'https://plus.unsplash.com/premium_photo-1726718645593-8d4d2ebfe845?auto=format&fit=crop&q=80&w=800' // Delicate feel
  },
  {
    title: 'Realism',
    desc: 'Tattoos that look like photographs. Highly detailed black and grey shading creates depth and dimension. Commonly used for portraits, wildlife, and cinematic imagery.',
    sizing: 'Medium to Large',
    priceGuide: '$$$$',
    img: 'https://plus.unsplash.com/premium_photo-1661765453479-a4c665564ae0?auto=format&fit=crop&q=80&w=800' // Detailed
  },
  {
    title: 'Traditional',
    desc: 'Also known as Old School. Features bold black outlines, a limited color palette (red, yellow, green, black), and iconic imagery like anchors, roses, and panthers.',
    sizing: 'Small to Large',
    priceGuide: '$$',
    img: 'https://images.unsplash.com/photo-1597852075234-fd721ac361d3?auto=format&fit=crop&q=80&w=800' // Traditional vibe
  }
];

const Styles = () => {
  return (
    <div className="pt-24 pb-20 bg-primary min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-6xl font-display mb-6">Tattoo Styles</h1>
          <div className="w-20 h-1 bg-secondary mx-auto mb-6"></div>
          <p className="text-muted max-w-2xl mx-auto">
            Understanding different tattoo styles helps in conceptualizing your piece. Explore the aesthetics we specialize in at Black Anchor.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {stylesData.map((style, idx) => (
            <motion.div 
              key={style.title}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="bg-background border border-gray-800 overflow-hidden group hover:border-secondary/50 transition-colors"
            >
              <div className="h-64 overflow-hidden relative">
                <img src={style.img} alt={style.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-background to-transparent"></div>
                <h3 className="absolute bottom-6 left-6 text-3xl font-display text-light">{style.title}</h3>
              </div>
              <div className="p-8">
                <p className="text-muted mb-6 h-24">{style.desc}</p>
                
                <div className="flex justify-between items-center border-t border-gray-800 pt-6">
                  <div>
                    <span className="block text-xs uppercase text-gray-500 mb-1">Recommended Size</span>
                    <span className="text-light text-sm">{style.sizing}</span>
                  </div>
                  <div className="text-right">
                    <span className="block text-xs uppercase text-gray-500 mb-1">Price Guide</span>
                    <span className="text-secondary font-medium">{style.priceGuide}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
        
        <div className="mt-20 p-10 bg-background border border-gray-800 text-center">
          <h3 className="text-2xl font-display mb-4">Looking for something custom?</h3>
          <p className="text-muted mb-6 max-w-2xl mx-auto">
            We love blending styles or creating something entirely unique. Bring us your concepts, references, and ideas, and we'll design a custom piece just for you.
          </p>
          <a href="#/booking" className="inline-block border border-secondary text-secondary px-8 py-3 hover:bg-secondary hover:text-primary transition-colors uppercase tracking-wider text-sm">
            Start Custom Project
          </a>
        </div>
      </div>
    </div>
  );
};

export default Styles;